import { useCallback, useState } from 'react';

export function useDialog(defaultValue = false) {
  const [isDialogOpen, setIsDialogOpen] = useState(defaultValue);

  const handleClose = useCallback(() => {
    setIsDialogOpen(false);
  }, []);

  const handleOpen = useCallback(() => {
    setIsDialogOpen(true);
  }, []);

  return {
    isDialogOpen,
    handleClose,
    handleOpen,
  };
}
